/**
 * 通用的工具函数
 */
import _cloneDeep from 'lodash/cloneDeep';

/**
 * 获取一个随机的UUID值
 * @returns
 */
const getUuid: () => string = () => {
  return S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4();
};

/**
 * 获取一个随机的4位字符
 * @returns
 */
const S4: () => string = () => {
  return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
};

/**
 * 深拷贝一个对象
 * @param obj
 * @returns
 */
const clone: (obj: any) => any = (obj) => {
  if (!['object'].includes(typeof obj)) {
    return null;
  }
  return _cloneDeep(obj);
};

/**
 * 将数字转换为万元亿等单位 12.31万
 * @param n 数字
 * @returns
 */
const formatNumberByUnit = (num, decimals = 2) => {
  //let p = /^[0-9]+?$/.test(place) ? place : 2;
  //小数点位数
  const _ws = Math.pow(10, decimals);
  //基础单位值
  const _b = 1e4;
  //小于最低值，直接返回
  if (num < _b) {
    return num.toString();
  }
  //返回值
  let _r = '';

  const _strArg = ['', '万', '亿', '万亿'];
  let _i = Math.floor(Math.log(num) / Math.log(_b));
  if (_i > 3) {
    _i = 3;
  }
  _r = Math.floor((num / Math.pow(_b, _i)) * _ws) / _ws + _strArg[_i];
  return _r;
};

/**
 * 格式化金额展示 123,456.12
 * @param money 金额
 * @param decimals 小数位数
 * @returns
 */
const formatCurrency = (money, decimals = 2) => {
  if (Number.isNaN(Number(money))) {
    return money;
  }
  return new Intl.NumberFormat('zh-CN', {
    style: 'currency', // 货币形式
    currency: 'CNY', // "CNY"是人民币
    currencyDisplay: 'symbol', // 默认“symbol”，中文中代表“¥”符号
    // useGrouping: true, // 是否使用分组分隔符，如千位分隔符或千/万/亿分隔符，默认为true
    // minimumIntegerDigits: 1, // 使用的整数数字的最小数目.可能的值是从1到21,默认值是1
    // minimumFractionDigits: 2, // 使用的小数位数的最小数目.可能的值是从 0 到 20
    maximumFractionDigits: decimals, // 使用的小数位数的最大数目。可能的值是从 0 到 20
  }).format(Number(money));
};

export { getUuid, clone, formatNumberByUnit, formatCurrency };
